import { z } from 'zod';

/**
 * Turn off Zod's eval-based schema compiler for the browser.
 *
 * Object schemas compile a fast path with `new Function` unless `jitless` is
 * already set when the schema is constructed. The CSP on the SPA is
 * report-only, so the call succeeds, but Chrome still reports it as
 * "Blocked 'script' from 'eval:'" (FRONTEND-PROD-44). The `allowsEval` probe
 * is itself a `new Function("")`, so the flag has to be set before the first
 * object schema is built, not merely before the first parse.
 *
 * Import this module before `zod/compile` and before any module that builds
 * schemas. `z.config` merges, so the later invalid-value error map keeps this
 * flag. Node entrypoints leave it off and keep `import "zod/compile"`.
 */
function disableZodEval(): void {
  z.config({ jitless: true });
}

disableZodEval();
